export default class Spmenu {
  constructor() {
    this.btn = $('.l-headerHumBtn');
    this.overlay = $('.l-headerOverlay');
    this.content = $('.l-header__nav');
    this.speed = 200;
  }
  init() {
    this.btn.on('click', e => {
      if (!$(e.currentTarget).hasClass('is_open')) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });
    this.overlay.on('click', () => {
      this.closeMenu();
    })
  }
  openMenu() {
    this.btn.addClass('is_open');
    this.overlay.fadeIn(this.speed);
    this.content.slideDown(this.speed);
  }
  closeMenu() {
    this.btn.removeClass('is_open');
    this.overlay.fadeOut(this.speed);
    this.content.slideUp(this.speed);
  }
}
